import {Component, output, OutputEmitterRef} from '@angular/core';
import {NgTemplateOutlet} from '@angular/common';
import {TranslatePipe} from "@ngx-translate/core";
import {RouterLink, RouterLinkActive} from "@angular/router";
import {CheckUserPermissionsDirective, UserPermission} from "@vision-inspection/shared";

@Component({
  selector: 'app-administration-menu',
  imports: [
    NgTemplateOutlet,
    TranslatePipe,
    RouterLink,
    RouterLinkActive,
    CheckUserPermissionsDirective
  ],
  templateUrl: './administration-menu.component.html',
  styleUrl: './administration-menu.component.scss'
})
export class AdministrationMenuComponent {
  public routerLinkActivated: OutputEmitterRef<void> = output<void>();

  protected administrationMenu: ({ label: string; link: string; userPermissions?: UserPermission[] })[] = [
    {
      label: 'administration.cameraConfiguration.link',
      link: '/administration/camera-configuration',
    },
    {
      label: 'administration.tenants.link',
      link: '/administration/tenants',
      userPermissions: [UserPermission.ViewPageTenants]
    },
  ];
}
